<template>
    <div class="step-box">
        <div class="step-head">Project Management</div>
        <div class="step-body">
            <div class="section-tip">
                <p>1. Before the submission deadline, the project can still be modified, you can click "Edit" to modify it.</p>
                <p>2. Please don't delete or unshare the project before the final results publish.</p>
                <p>3. If you need to submit a new project, modify your personal information or poster, please cancel the submission and resubmit again.</p>
            </div>
            <div class="work">
                <img class="poster" :src="myPostInfo.coverUrl">
                <div class="title">{{myPostInfo.title}}</div>
            </div>
            <div class="op-box">
                <a href="javascript:" class="btn secondary" @click="cancelPost">Cancel Submission</a>
                <a :href="editUrl" class="btn primary" target="_blank">Edit Project</a>
            </div>
        </div>
        <Modal :show-modal="showModal" :msg="msg" :need-cancel="true" @confirmModal="confirmModal" @cancelModal="cancelModal"></Modal>
    </div>
</template>

<script>
    import Modal from '../../components/modal'
    export default {
        name: "success",
        props: {
          myPostInfo: Object
        },
        components: {
            Modal
        },
        data() {
            return {
                showModal: false,
                msg: 'If you cancel the submission, the information submitted before will all be deleted. Are you sure to cancel?',
                cancelProjectId: 0,
                editUrl: `${process.env.VUE_APP_EDIT_URL}${this.myPostInfo.projectId}`,
            }
        },
        methods: {
            cancelPost() {
                this.showModal = true
            },
            confirmModal() {
                this.showModal = false
                this.$emit('cancelPost', this.myPostInfo.projectId)
            },
            cancelModal() {
                this.showModal = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .work {
        width: 286px;
        margin: 0 auto 50px;
        background: rgba(2, 27, 63, .7);
        padding: 8px 0;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;

        .poster {
            width: 271px;
            height: 204px;
            border-radius: 10px;
            margin-bottom: 8px;
        }

        .title {
            width: 271px;
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            color: #fff;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 auto 5px;
            text-align: left;
        }
    }
</style>
